// extracted by mini-css-extract-plugin
export var black = "_4m-6";
export var brand = "_4m-1";
export var ddefault = "_4m-0";
export var error = "_4m-3";
export var gray = "_4m-2";
export var highContrast = "_4m-8";
export var outline = "_4m-7";
export var success = "_4m-5";
export var warning = "_4m-4";